export const config = {
  apiUrl: process.env.API_URL,
}
